import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { email: string; password: string }
    >({
      query: (credentials) => ({
        url: "auth/login",
        method: "POST",
        data: credentials,
      }),
    }),

    loginWithGoogle: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { code: string; scope: string }
    >({
      query: (credentials) => ({
        url: "auth/google",
        method: "POST",
        data: credentials,
      }),
    }),

    loginWithMicrosoft: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { code: string; redirectUri: string }
    >({
      query: (credentials) => ({
        url: "auth/microsoft",
        method: "POST",
        data: credentials,
      }),
    }),

    sendEmail: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `auth/forgot-password`,
        method: "POST",
        data: credentials,
      })
    }),
    sendNewPassword: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `auth/reset-password`,
        method: "POST",
        data: credentials,
      })
    }),

    signup: builder.mutation<
      Response<any>,
      {
        first_name: string;
        last_name: string;
        email: string;
        country: string;
        company_name: string;
        phone_number: string;
        company_size: string;
        preferred_gift_type: string;
      }
    >({
      query: (credentials) => ({
        url: "user/signup",
        method: "POST",
        data: credentials,
      }),
    }),

  }),
});

export const { useLoginMutation, useLoginWithGoogleMutation, useLoginWithMicrosoftMutation, useSendEmailMutation, useSendNewPasswordMutation, useSignupMutation } = authApi;
